import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AsyncPipe } from '@angular/common';

import { PUBLIC_ROUTES } from './constants/application-routes';
import { ZciCookieService } from './services/zci-cookie/zci-cookie.service';
import { UserAgentService } from './services/user-agent/user-agent.service';
import { VgnService } from './services/vgn/vgn.service';
import { loadAccountUsers } from './store/actions/account-permissions-page.action';
import {
    getLoadingStateForClientSegment,
} from './store/selectors/account-permissions.selector';
import { LoadingDirective } from './directives/loading.directive';

@Component({
    selector: 'zci-root',
    templateUrl: 'app.component.html',
    standalone: true,
    imports: [RouterOutlet, AsyncPipe, LoadingDirective],
})
export class AppComponent implements OnInit, OnDestroy {
    private readonly store = inject(Store);
    private router = inject(Router);
    private cookieService = inject(ZciCookieService);
    private readonly userAgentService = inject(UserAgentService);
    private readonly vgnService = inject(VgnService);

    isMobileApp: boolean = false;

    isClientSegmentLoading$: Observable<boolean> = this.store.select(
        getLoadingStateForClientSegment,
    );

    readonly subs: Subscription = new Subscription();

    ngOnInit(): void {
        this.isMobileApp = this.userAgentService.isBeaconFound();

        if (this.isMobileApp) {
            this.vgnService.setGlobalNav();
        }

        if (
            !this.isPublicRoute(window.location.pathname) &&
            !window.location.pathname.includes('accept-access/')
        ) {
            this.store.dispatch(loadAccountUsers());
        }

        if (!this.isPublicRoute(window.location.pathname)) {
            // @ts-expect-error spoid is not defined in window
            window.spoid = this.cookieService.sPOID;
        }
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private isPublicRoute(url: string): boolean {
        return Object.values(PUBLIC_ROUTES).some((route) => {
            if (route.includes(':token')) {
                const staticPart = route.split('/:')[0];
                return url.startsWith(`/${staticPart}`);
            }
            return url === `/${route}`;
        });
    }
}
